import React from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';

const localizer = momentLocalizer(moment);
const DragAndDropCalendar = withDragAndDrop(BigCalendar);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const eventPropGetter = (event: any) => {
  // A CSS variable rather than backgroundColor: agenda view applies this style to its
  // whole <tr>, and only .rbc-event reads the variable (see CreateAppointmentModal/styles.scss).
  const style = {
    '--event-color': event.data?.appointment?.appointmentType?.color,
  } as React.CSSProperties;

  if (new Date(event.end) < new Date()) {
    return { style: { ...style, opacity: 0.6, filter: 'grayscale(20%)' } };
  }

  return { style };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Calendar(props: any) {
  return (
    <DragAndDropCalendar 
      {...props} 
      localizer={localizer} 
      eventPropGetter={eventPropGetter}
      resizable={true}
      resizableAccessor={() => true}
    />
  );
}